import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "style"]
  static values = {
    inputId: String,
    fallback: { type: String, default: "Your Signature" }
  }

  connect() {
    this.input = document.getElementById(this.inputIdValue)
    this.refresh = this.refresh.bind(this)

    if (this.input) {
      this.input.addEventListener("input", this.refresh)
      requestAnimationFrame(this.refresh)
    } else {
      this.refresh()
    }
  }

  disconnect() {
    if (this.input) {
      this.input.removeEventListener("input", this.refresh)
    }
  }

  refresh() {
    const displayValue = this.input?.value?.trim() || this.fallbackValue
    const style = this.styleTargets.find((field) => field.checked)?.value || "classic"

    this.previewTarget.textContent = displayValue
    this.previewTarget.classList.remove(
      "signature-style-picker__preview--classic",
      "signature-style-picker__preview--formal",
      "signature-style-picker__preview--casual"
    )
    this.previewTarget.classList.add(`signature-style-picker__preview--${style}`)
  }
}
